module.exports = __webpack_public_path__ + "ac31d2c0ff6e885d9ac45b0b14b98c72.png";